import React from 'react';
import PropTypes from 'prop-types';

import { Pagination, PaginationItem } from '@material-ui/lab';

import { Container } from './styles';

const PaginationComponent = ({ searchText, page, count, handlePage }) => {
  return (
    <Container>
      <Pagination
        page={page}
        count={count}
        onChange={(event, value) => handlePage(searchText, value)}
        renderItem={(item) => <PaginationItem disableRipple {...item} />}
        variant="outlined"
        shape="rounded"
      />
    </Container>
  );
};

PaginationComponent.propTypes = {
  searchText: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  handlePage: PropTypes.func.isRequired,
};

export default PaginationComponent;
